import { Item } from '../../item/item.class';

// Takes Item, not PanelItem like most siblings, because it runs mid-constructor before `this` is a complete PanelItem
/**
 * Resolves the starting center.y for a brand-new PanelItem from its item's catalog defaultPlacement.
 * @param item Item whose catalog defaultPlacement drives the position
 * @param panelHeight height of the panel the item is being placed on
 * @returns panel-relative center.y, or null when no vertical default is set
 */
export const getDefaultPlacementCenterYCfn = (item: Item, panelHeight: number): number | null => {
	if (!item.defaultPlacement) return null;

	const { top, bottom } = item.defaultPlacement;
	const halfPanelHeight = panelHeight / 2;
	const halfItemHeight = item.component.size.height / 2;

	if (typeof top === 'number') return -halfPanelHeight + top + halfItemHeight;
	if (typeof bottom === 'number') return halfPanelHeight - bottom - halfItemHeight;

	return null;
};
